import { render, staticRenderFns } from "./Askus.vue?vue&type=template&id=828f863c&scoped=true&"
import script from "./Askus.vue?vue&type=script&lang=js&"
export * from "./Askus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "828f863c",
  null
  
)

export default component.exports